
import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

import enLang from './locales/en/en.json';
import zhLang from './locales/zh/zh.json';

// const resources = {
//   en: {
//     translation: enLang
//   },
//   zh: {
//     translation: zhLang
//   },
// }

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      'en-HK': {
        translation: enLang,
      },
      'zh-HK': {
        translation: zhLang,
      },
    },
    // returnNull: false,
    supportedLngs: ['en-HK', 'zh-HK'],
    fallbackLng: 'en-HK',
    lng: "en-HK",
    // lng: window.localStorage.i18nextLng || 'en',
    // debug: true,
    interpolate: {
      escapeValue: false,
    },
  })

export default i18n;